import { useState, useCallback } from 'react';
import { formatConversationAsText } from '../utils/conversation-formatters';
import type { Message } from '../types';

/**
 * Hook for copying conversation to clipboard with feedback
 */
export function useCopyConversation() {
  const [copied, setCopied] = useState(false);
  const [copying, setCopying] = useState(false);

  const copyConversation = useCallback(async (
    messages: Message[],
    sessionId: string
  ) => {
    if (copying) return false;

    setCopying(true);
    try {
      const txtContent = formatConversationAsText(messages, sessionId);
      await navigator.clipboard.writeText(txtContent);
      setCopied(true);
      // Reset feedback after 2 seconds
      setTimeout(() => setCopied(false), 2000);
      return true;
    } catch (error) {
      console.error('Failed to copy conversation:', error);
      return false;
    } finally {
      setCopying(false);
    }
  }, [copying]);

  return { copyConversation, copied, copying };
}
